<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12 ">
        <div class="card h-100 mt-3">
          <div class="card-header mb-0">
            <div class="row no-gutters">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5>{{ $t('content.mbankp') }}</h5>
                <div>
                  <material-button color="primary" class="float-lg-start float-sm-end mb-0" @click="addNewItems">
                    <i class="material-icons material-symbols-outlined">add</i> {{ btnAddNew }}
                  </material-button>
                </div>
              </div>
            </div>

          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="table-responsive">
                <table class="table">
                  <thead class="thead-light">
                    <tr>
                      <th style="min-width: 70px;">#</th>
                      <th style="min-width: 120px;">{{ $t('content.mbankpshort') }}</th>
                      <th style="min-width: 250px;">{{ $t('content.mbankname') }}</th>
                      <th style="min-width: 120px;">{{ $t('content.cbankno') }}</th>
                      <th style="min-width: 120px;">{{ $t('content.amnmoneylimit') }}</th>
                      <th style="min-width: 240px;">{{ $t('content.note') }}</th>
                      <th colspan="4" class="align-top text-center">{{ $t('content.amnchannel') }}</th>
                      <th>{{ $t('content.act') }}</th>
                    </tr>
                    <tr>
                      <th colspan="6"></th>
                      <th class="align-top text-center">
                        {{ $t("content.fo_mobile") }}
                      </th>
                      <th class="align-top text-center">
                        {{ $t("content.fo_web") }}
                      </th>
                      <th class="align-top text-center">
                        {{ $t("content.bo_mobile") }}
                      </th>
                      <th class="align-top text-center">
                        {{ $t("content.bo_web") }}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="group-id-ticket">
                      <td class="text-sm font-weight-normal">
                        <div class="group-tickect">
                          <h6 class="mb-0"><b>{{ btnSearch }}</b></h6>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="filtershortName" type="text" class="mb-0" :label="lbShort" />
                      </td>
                      <td class="text-sm font-weight-normal" colspan="3">
                        <div class="card flex justify-content-center">
                          <Dropdown v-model="filterBankUid" :options="listbank" optionLabel="uid"
                            placeholder="Select a Bank" class="w-full md:w-auto">
                            <template #value="slotProps">
                              <div v-if="slotProps.value" class="both">
                                <div class="bank-logo">
                                  <img :src="slotProps.value.thumb" style="background-position:0 ; width: 18px" />
                                </div>
                                &nbsp;&nbsp;
                                <div>{{ slotProps.value.nameTh }} ( {{ slotProps.value.nameEn }} )</div>
                              </div>
                              <span v-else>
                                {{ slotProps.placeholder }}
                              </span>
                            </template>

                            <template #option="slotProps">
                              <div class="both">
                                <div class="bank-logo">
                                  <img :src="slotProps.option.thumb" style="background-position:0 ; width: 18px" />
                                </div>&nbsp;&nbsp;
                                <div>{{ slotProps.option.nameTh }} ( {{ slotProps.option.nameEn }} )</div>
                              </div>
                            </template>
                          </Dropdown>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal" colspan="3">
                        <material-input v-model="filteracctNumber" type="text" class="mb-0"
                          :label="$t('content.cbankno')" @input="onlyDigits_filteracctNumber" />
                      </td>
                      <td colspan="2" class="text-sm font-weight-normal">
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch" @click="loadDataApi">
                          <i class="material-icons material-symbols-outlined">search</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr v-if="datas.addNew">
                      <td class="text-sm font-weight-normal">#</td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="shopbank_detail.shortName" type="text" class="mb-0" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <div class="card flex justify-content-center">
                          <Dropdown v-model="selectedBankAdd" :options="listbank" optionLabel="nameTh"
                            placeholder="Select a Bank" class="w-full md:w-auto mb-0 ">
                            <template #value="slotProps">
                              <div v-if="slotProps.value" class="both">
                                <div class="bank-logo">
                                  <img :src="slotProps.value.thumb" style="background-position:0 ; width: 18px" />
                                </div>
                                &nbsp;&nbsp;
                                <div>{{ slotProps.value.nameTh }} ( {{ slotProps.value.nameEn }} )</div>
                              </div>
                              <span v-else>
                                {{ slotProps.placeholder }}
                              </span>
                            </template>

                            <template #option="slotProps">
                              <div class="both">
                                <div class="bank-logo">
                                  <img :src="slotProps.option.thumb" style="background-position:0 ; width: 18px" />
                                </div>&nbsp;&nbsp;
                                <div>{{ slotProps.option.nameTh }} ( {{ slotProps.option.nameEn }} )</div>
                              </div>
                            </template>
                          </Dropdown>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="shopbank_detail.acctNumber" type="text" class="mb-0"
                          @input="onlyDigits" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <InputNumber v-model="shopbank_detail.maxLimit" :minFractionDigits="0" :maxFractionDigits="2"
                          class="mb-0" autocomplete="off" @focus="$event.target.select()" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="shopbank_detail.note" type="text" class="mb-0" />
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="FO_MOBILE" :checked="FO_MOBILE" />
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="FO_WEB" :checked="FO_WEB" />
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="BO_MOBILE" :checked="BO_MOBILE" />
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="BO_WEB" :checked="BO_WEB" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="primary" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSave" :disabled="shopbank_detail.shortName.trim() === '' || selectedBankAdd === '' ||
                            shopbank_detail.acctNumber === '' || shopbank_detail.maxLimit === '' || shopbank_detail.maxLimit === null || shopbank_detail.maxLimit === '0' || parseFloat(shopbank_detail.maxLimit) === 0 ||
                            shopbank_detail.note.trim() === ''" @click="saveNewItems">
                          <i class="material-icons material-symbols-outlined">save</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnClose"
                          @click="cancelSaveNewItems">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </material-button>
                      </td>
                    </tr>


                    <tr v-for="(row, index) in list" :key="index">
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal">
                        <material-input v-model="shopbank_detail.shortName" type="text" class="mb-0" />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal">
                        <div class="card flex justify-content-center">
                          <Dropdown v-model="selectedBankAdd" :options="listbank" optionLabel="nameTh"
                            placeholder="Select a Bank" class="w-full md:w-auto mb-0 ">
                            <template #value="slotProps">
                              <div v-if="slotProps.value" class="both">
                                <div class="bank-logo">
                                  <img :src="slotProps.value.thumb" style="background-position:0 ; width: 18px" />
                                </div>
                                &nbsp;&nbsp;
                                <div>{{ slotProps.value.nameTh }} ( {{ slotProps.value.nameEn }} )</div>
                              </div>
                              <span v-else>
                                {{ slotProps.placeholder }}
                              </span>
                            </template>

                            <template #option="slotProps">
                              <div class="both">
                                <div class="bank-logo">
                                  <img :src="slotProps.option.thumb" style="background-position:0 ; width: 18px" />
                                </div>&nbsp;&nbsp;
                                <div>{{ slotProps.option.nameTh }} ( {{ slotProps.option.nameEn }} )</div>
                              </div>
                            </template>
                          </Dropdown>
                        </div>
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal">
                        <material-input v-model="shopbank_detail.acctNumber" type="text" class="mb-0"
                          @input="onlyDigits" />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal">
                        <InputNumber v-model="shopbank_detail.maxLimit" :minFractionDigits="0" :maxFractionDigits="2"
                          class="mb-0" autocomplete="off" @focus="$event.target.select()" />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal">
                        <material-input v-model="shopbank_detail.note" type="text" class="mb-0" />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="FO_MOBILE" :checked="FO_MOBILE" />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="FO_WEB" :checked="FO_WEB" />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="BO_MOBILE" :checked="BO_MOBILE" />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox v-model="BO_WEB" :checked="BO_WEB" />
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal">
                        {{ row.shortName }}
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal">
                        <span>
                          <div class="both">
                            <div class="bank-logo">
                              <img :src="row.bankDetail.thumb" style="background-position:0 ; width: 18px" />
                            </div>&nbsp;&nbsp;
                            <div>{{ row.bankDetail.nameTh }} ( {{ row.bankDetail.nameEn }} )</div>
                          </div>
                        </span>
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal">
                        {{ row.acctNumber }}
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal">
                        {{ formatNumberString(row.maxLimit) }}
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal">
                        {{ row.note }}
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox :checked="row.FO_MOBILE" disabled />
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox :checked="row.FO_WEB" disabled />
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox :checked="row.BO_MOBILE" disabled />
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal text-center">
                        <material-checkbox :checked="row.BO_WEB" disabled />
                      </td>
                      <td v-if="row.uid === shopbank_detail.uid" class="text-sm font-weight-normal">
                        <material-button color="primary" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSave" :disabled="shopbank_detail.shortName.trim() === '' || selectedBankAdd === '' ||
                            shopbank_detail.acctNumber === '' || shopbank_detail.maxLimit === '' || shopbank_detail.maxLimit === null || shopbank_detail.maxLimit === '0' || parseFloat(shopbank_detail.maxLimit) === 0 ||
                            shopbank_detail.note.trim() === ''" @click="saveEditRowItems">
                          <i class="material-icons material-symbols-outlined">save</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnClose"
                          @click="cancelEditRowItems">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </material-button>
                      </td>
                      <td v-if="row.uid !== shopbank_detail.uid" class="text-sm font-weight-normal">
                        <material-button color="info" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnEdit" @click="editRowItems(row)">
                          <i class="material-icons material-symbols-outlined">edit</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnDel" @click="deleteRowItems(row)">
                          <i class="material-icons material-symbols-outlined">delete</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr v-if="list.length === 0">
                      <td colspan="10" class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="15" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <pre></pre>
            <div style="display: flex; justify-content: flex-end">
              <ul v-show="list.length > 0" class="pagination justify-content-end">
                <div class="project-container">
                  <div class="example-one">
                    <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                      @click="onClickHandler" />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import { reactive, inject, computed, ref } from 'vue'
import { useI18n } from "vue-i18n"
import moment from 'moment'
import MaterialButton from "@/components/MaterialButton.vue"
import MaterialInput from "@/components/MaterialInput.vue"
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";


import axios from "axios";
import noimg from "@/assets/img/noimg.png"
import * as st from "@/config/setting.js";
import { useBankStore } from '@/stores/bank'
import { useShopBankStore } from '@/stores/shopbank'
import { useCloseBankStore } from '@/stores/closebank'
import { useDocumentStore } from '@/stores/document'

const { t } = useI18n()
const swal = inject('$swal')

const storeb = useBankStore()
const storesb = useShopBankStore()
const storecb = useCloseBankStore()
const storedoc = useDocumentStore()

const datas = reactive({
  addNew: false,
  rowEdit: false,
  demo1: [
    { items: "ประเภท1.1" },
    { items: "ประเภท1.2" },
    { items: "ประเภท1.3" },
    { items: "ประเภท1.4" },
    { items: "ประเภท1.5" },
    { items: "ประเภท1.6" }
  ]
})

const btnAddNew = computed(() => t("buttons.impo"))
const btnEdit = computed(() => t("buttons.edit"))
const btnSearch = computed(() => t("buttons.sear"))
const btnSave = computed(() => t("buttons.save"))
const btnDel = computed(() => t("buttons.remo"))
const btnClose = computed(() => t("buttons.clos"))

const lbShort = computed(() => t("content.mbankpshort"))

const list = ref([]);

const listbank = ref([]);
const lb = ref([]);
const urls = ref([]);

const selectedBankAdd = ref('');

const filterBankUid = ref('');
const filtershortName = ref('');
const filteracctNumber = ref('');

const shopbank_detail = ref({
  uid: '',
  bankUid: '',
  shopUid: '',
  shortName: '',
  acctNumber: '',
  maxLimit: '',
  note: '',
  version: '',
  channels: []
})

const channels = ref([]);
const FO_MOBILE = ref(false);
const FO_WEB = ref(false);
const BO_MOBILE = ref(false);
const BO_WEB = ref(false);

const onClickHandler = (page) => {
  updatePagination()
};
const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(10);
const totalRows_s = ref();
const key = JSON.parse(localStorage.getItem("shop_seleted"));

const loadBankMasterApi = async (val) => {
  let data = "";
  lb.value = [];
  urls.value = []; // คงการเคลียร์ค่าไว้ตามโครงสร้างเดิมของระบบคุณ

  data = {
    index: "0",
    size: 100,
    nameTh: '',
    nameEn: '',
  };
  
  const payload = data;
  const response = await storeb.bankListFetch(payload);

  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      listbank.value = response.data.data.list;
      loadDataApi(); // รันฟังก์ชันตามฟลูดั้งเดิมของคุณ
      
      // 1. เซ็ตค่าพรีวิวเริ่มต้นให้กับรูปตารางของธนาคาร (Fallback เป็นภาพ noimg เผื่อไฟล์โหลดไม่ผ่าน)
      listbank.value.forEach(function (obj) {
        obj.thumb = noimg;
        obj.file = null;
        obj.data = null;
      });

      // 2. 🟢 เปลี่ยนจุดเช็ค: ตรวจสอบว่าในข้อมูลรอบนี้ มีแถวข้อมูลธนาคารไหนที่มีโลโก้จริงบ้าง (logoUid ไม่เป็น "0")
      // แทนการใช้ลูปวนสร้างอาเรย์ urls สตริงแบบเดิม
      const hasLogos = listbank.value.some(item => item.logoUid && item.logoUid !== "0");
      
      if (hasLogos) {
        // 🟢 ฝากส่งค่าเข้าไปประมวลผลที่อาเรย์หลัก lb เพื่อให้ getFileLoco ค้นหาแถวแมตช์ได้ถูกต้อง
        lb.value = listbank.value;
        
        // 🟢 3. สั่งรันฟังก์ชันดึงโลโก้ธนาคารขนานแบบ POST ตัวใหม่ที่เราเคลียร์บั๊กไว้แล้ว
        await getFileLoco();
        
        // ดึงผลลัพธ์ที่ผูกลิงก์รูปภาพสะอาดไร้อาการออโต้ดาวน์โหลดกลับคืนตารางหลัก
        listbank.value = lb.value;
      }
    }
  }
};

loadBankMasterApi()

const loadDataApi = async (val) => {
  clearItem()
  if (currentPage.value !== 1) {
    if (list.value.length === 1 && val === 'del') {
      currentPage.value = currentPage.value - 1
    }
  }
  let data = "";
  let listdata = []
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    bankUid: filterBankUid.value.uid,
    shortName: filtershortName.value,
    acctNumber: String(filteracctNumber.value),
    shopUid: key.uid
  };
  const payload = data;
  // const response = await store.dispatch("unitListFetch", payload);
  // console.log("load payload : " + JSON.stringify(data));
  const response = await storesb.shopbankListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listdata = response.data.data.list;
        listdata.map(function (x) {
          const lf = filterData(x.bankUid, listbank.value)
          // console.log("lf : " + JSON.stringify(lf));
          x.bankDetail = lf[0]
          x.FO_MOBILE = false
          x.FO_WEB = false
          x.BO_MOBILE = false
          x.BO_WEB = false
          return x
        });
        for (let i = 0; i < listdata.length; i++) {
          if (listdata[i].channels.includes('FO_MOBILE')) {
            listdata[i].FO_MOBILE = true
          }
          if (listdata[i].channels.includes('FO_WEB')) {
            listdata[i].FO_WEB = true
          }
          if (listdata[i].channels.includes('BO_MOBILE')) {
            listdata[i].BO_MOBILE = true
          }
          if (listdata[i].channels.includes('BO_WEB')) {
            listdata[i].BO_WEB = true
          }
        }
        list.value = listdata
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }


};




async function updatePagination() {
  let listdata = []
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    bankUid: filterBankUid.value.uid,
    shortName: filtershortName.value,
    acctNumber: String(filteracctNumber.value),
    shopUid: key.uid
  };
  const payload = data;
  // const response = await store.dispatch("unitListFetch", payload);
  const response = await storesb.shopbankListFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listdata = response.data.data.list;
        listdata.map(function (x) {
          const lf = filterData(x.bankUid, listbank.value)
          // console.log("lf : " + JSON.stringify(lf));
          x.bankDetail = lf[0]
          x.FO_MOBILE = false
          x.FO_WEB = false
          x.BO_MOBILE = false
          x.BO_WEB = false
          return x
        });
        for (let i = 0; i < listdata.length; i++) {
          if (listdata[i].channels.includes('FO_MOBILE')) {
            listdata[i].FO_MOBILE = true
          }
          if (listdata[i].channels.includes('FO_WEB')) {
            listdata[i].FO_WEB = true
          }
          if (listdata[i].channels.includes('BO_MOBILE')) {
            listdata[i].BO_MOBILE = true
          }
          if (listdata[i].channels.includes('BO_WEB')) {
            listdata[i].BO_WEB = true
          }
        }
        list.value = listdata
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        // console.log('list : '+list.value.length)
      }
    }
  }
}


function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function filterData(str, matchArr) {
  return matchArr.filter((c) => c.uid === str);
}


async function getFileLoco() {
  // 1. กรองเอาเฉพาะข้อมูลแถวในตารางที่มีการผูกโลโก้จริง (logoUid ไม่เป็น "0")
  const validItems = lb.value.filter(item => item.logoUid && item.logoUid !== "0");

  if (validItems.length > 0) {
    // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload ยิงเข้า Store ส่วนกลาง
    const requests = validItems.map((item) => {
      const filePayload = {
        groupUid: key.groupUid, // หรือใส่ตัวแปรที่ใช้ดักกรุ๊ป/ร้านค้าของหน้านี้
        shopUid: "0",  
        uid: String(item.logoUid) // รหัสไอดีโลโก้ธนาคารแถวนั้นๆ
      };
      
      // เรียกใช้ผ่าน Store ส่วนกลางที่แก้เป็น POST + Blob เรียบร้อยแล้ว
      return storedoc.getFileFetch(filePayload); // 💡 ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ (เช่น storedoc หรือ storeb)
    });

    try {
      // 🟢 3. ยิงดาวน์โหลดทุกโลโก้พร้อมกันแบบขนานรวดเดียวด้วย Promise.all ตามมาตรฐานใหม่
      const allResults = await Promise.all(requests);
      
      if (allResults) {
        for (let i = 0; i < allResults.length; i++) {
          if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
            const rawData = allResults[i].data;
            const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
            
            if (isBlob) {
              // 🟢 4. สแกนตรวจสอบเนื้อไฟล์ดิบเพื่อล้างประวัติติดคำสั่งดาวน์โหลดออโต้จากหลังบ้าน
              const textHead = await rawData.slice(0, 4).text();
              let cleanBlob;

              if (textHead === "%PDF") {
                cleanBlob = new Blob([rawData], { type: 'application/pdf' });
              } else if (textHead.startsWith("PK")) {
                cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              } else {
                // 🖼️ ครอบหัวเป็นรูปภาพใหม่ที่สะอาด 100% บนหน้าบ้าน รูปโลโก้จะไม่แตกและไม่เด้งดาวน์โหลด
                cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
              }

              const dataUrl = URL.createObjectURL(cleanBlob);
              const matchedItem = validItems[i];
              
              // 🟢 5. วิ่งไปค้นหาออบเจกต์แถวที่แมตช์กันโดยใช้ฟังก์ชัน filterFile ดั้งเดิมของหน้านี้
              const lf = filterFile(matchedItem.logoUid, lb.value);
              
              if (lf && lf.length > 0) {
                lf[0].thumb = dataUrl;
                lf[0].file = cleanBlob;
                lf[0].data = dataUrl;
              }
            }
          }
        }
      }
    } catch (e) {
      console.error("Error in Promise.all getFileLoco:", e);
    }
  }
}



function filterFile(str, matchArr) {
  //  return matchArr.filter((c) => c.data.data.uid === str);
  return matchArr.filter((c) => c.logoUid === str);
}

async function onlyDigits_filteracctNumber() {

  if (filteracctNumber.value !== "") {
    if (filteracctNumber.value.match(/^[0-9]+$/)) {
      filteracctNumber.value = filteracctNumber.value.match(/^[0-9]+$/);

    } else {
      filteracctNumber.value = filteracctNumber.value.slice(0, -1);
    }
  } else {
    filteracctNumber.value = "";
  }
}

async function onlyDigits() {

  if (shopbank_detail.value.acctNumber !== "") {
    if (shopbank_detail.value.acctNumber.match(/^[0-9]+$/)) {
      shopbank_detail.value.acctNumber = shopbank_detail.value.acctNumber.match(/^[0-9]+$/);

    } else {
      shopbank_detail.value.acctNumber = shopbank_detail.value.acctNumber.slice(0, -1);
    }
  } else {
    shopbank_detail.value.acctNumber = "";
  }
}


function clearItem() {
  datas.addNew = false
  datas.rowEdit = false
  selectedBankAdd.value = ''
  shopbank_detail.value = {
    uid: '',
    bankUid: '',
    shopUid: '',
    shortName: '',
    acctNumber: '',
    maxLimit: '',
    note: '',
    version: '',
    channels: []
  }
  FO_MOBILE.value = false
  FO_WEB.value = false
  BO_MOBILE.value = false
  BO_WEB.value = false
  channels.value = []
}

async function addNewItems() {
  swal({
    title: "เพิ่มรายการ",
    text: "คุณต้องการเพิ่มรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      clearItem()
      datas.addNew = true
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกรายการ", "", "error")
      datas.addNew = false
    }
  })
}

async function saveNewItems() {
  swal({
    title: "ต้องการบันทึกรายการนี้",
    text: "คุณต้องการบันทึกรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.save'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      // swal("บันทึกสำเร็จ", "", "success")
      datas.addNew = false
      addshopbank()
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกการบันทึก", "", "error")
      datas.addNew = false
    }
  })
}

async function cancelSaveNewItems() {
  swal({
    title: "ยกเลิกบันทึกรายการนี้",
    text: "คุณต้องการยกเลิกบันทึกรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      datas.addNew = false
      clearItem()
    } else if (result.dismiss == 'cancel') {
      datas.addNew = true
    }
  })
}

async function editRowItems(item) {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      clearItem()
      selectedBankAdd.value = item.bankDetail
      shopbank_detail.value = {
        uid: item.uid,
        bankUid: item.bankUid,
        shortName: item.shortName,
        acctNumber: item.acctNumber,
        maxLimit: item.maxLimit,
        note: item.note,
        version: item.version,
      }
      FO_MOBILE.value = item.FO_MOBILE
      FO_WEB.value = item.FO_WEB
      BO_MOBILE.value = item.BO_MOBILE
      BO_WEB.value = item.BO_WEB
      datas.rowEdit = true
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกรายการ", "", "error")
      datas.rowEdit = false
    }
  })
}

async function saveEditRowItems() {
  swal({
    title: "บันทึกแก้ไขรายการ",
    text: "คุณต้องการบันทึกแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.save'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      // swal("บันทึกสำเร็จ", "", "success")
      datas.rowEdit = false
      if (shopbank_detail.value.uid !== "" && shopbank_detail.value.version !== "") {
        updateshopbank()
      }
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกแก้ไข", "", "error")
      datas.rowEdit = false
    }
  })
}

async function cancelEditRowItems() {
  swal({
    title: "ยกเลิกแก้ไขรายการ",
    text: "คุณต้องการยกเลิกแก้ไขรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      datas.rowEdit = false
      clearItem()
    } else if (result.dismiss == 'cancel') {
      datas.rowEdit = true
    }
  })
}


async function deleteRowItems(item) {
  swal({
    title: "ลบรายการ",
    text: "คุณต้องการลบรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        deleteshopbank(item.uid);
      }
    }
  });
}

async function addshopbank() {
  channels.value = []
  await findChannels()
  shopbank_detail.value.bankUid = selectedBankAdd.value.uid
  shopbank_detail.value.acctNumber = String(shopbank_detail.value.acctNumber)
  shopbank_detail.value.shopUid = key.uid
  shopbank_detail.value.channels = channels.value
  const payload = shopbank_detail.value;
  // console.log('addItems 1 : ' + JSON.stringify(payload));
  const response = await storesb.shopbankAddFetch(payload);
  // console.log('addItems 2 : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await loadDataApi('add');
        await addCloseBankOpenshop(response.data.data)
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function updateshopbank() {
  channels.value = []
  await findChannels()
  shopbank_detail.value.bankUid = selectedBankAdd.value.uid
  shopbank_detail.value.acctNumber = String(shopbank_detail.value.acctNumber)
  shopbank_detail.value.shopUid = key.uid
  shopbank_detail.value.channels = channels.value
  const payload = shopbank_detail.value;
  // const response = await store.dispatch("unitUpdateFetch", payload);
  const response = await storesb.shopbankUpdateFetch(payload);
  // console.log('editItems : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('edit');
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function deleteshopbank(id) {
  let data = "";
  data = {
    uid: id,
  };
  const payload = data;
  // const response = await store.dispatch("unitDeleteFetch", payload);
  const response = await storesb.shopbankDeleteFetch(payload);
  // console.log('loadDataApi : '+JSON.stringify(response));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('del');
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function addCloseBankOpenshop(item) {
  let payload = ""
  payload = {
    bankAccUid: item.uid,
    closingDateTime: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
    totalAmount: 0.00,
    bankAccName: filterBankacc(item.uid).trim()
  }
  // console.log('acb p : ' + JSON.stringify(payload));
  const response = await storecb.closeBankNewOpenshopFetch(payload);
  // console.log('acb r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // loadDataApi('update')
        // swal("บันทึกสำเร็จ", "", "success");
      } else {
        // swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function findChannels() {
  let allow = []
  if (FO_MOBILE.value) {
    allow.push('FO_MOBILE')
  }
  if (FO_WEB.value) {
    allow.push('FO_WEB')
  }
  if (BO_MOBILE.value) {
    allow.push('BO_MOBILE')
  }
  if (BO_WEB.value) {
    allow.push('BO_WEB')
  }

  channels.value = allow
}


function filterBankacc(str) {
  let name = list.value.filter((c) => c.uid === str);
  return name[0].shortName;
}

</script>

<style lang="scss" scoped>
div.both {
  display: flex;
}
</style>